export { MarketTrophiesPage } from './MarketTrophiesPage'
